import { useDeliveryApi } from 'infrastructure/api';
import projectNoteValidation from './createupdate/projectNoteValidation';
import projectCloseoutValidation from './createupdate/projectCloseoutValidation';

const useProjectNotesService = () => {
  const { sendPostRequest, sendPatchRequest, sendDeleteRequest, sendGetRequest } = useDeliveryApi();

  const createUserNote = async (projectId: string, command: { text: string; attachmentPaths?: string[] }) => {
    const response = await sendPostRequest(`/projects/${projectId}/timeline`, {
      text: command.text,
      attachmentPaths: command.attachmentPaths || [],
    });

    return response.json();
  };

  const updateUserNote = async (id: string, command: { text: string; attachmentPaths?: string[] }) => {
    const response = await sendPatchRequest(`/projects/timeline/${id}`, {
      text: command.text,
      attachmentPaths: command.attachmentPaths || [],
    });

    return response.json();
  };

  const deleteUserNote = async (id: string) => {
    return await sendDeleteRequest(`/projects/timeline/${id}`, {});
  };

  const pinNote = async (timelineId: string, pinStatus: boolean) => {
    const response = await sendPatchRequest(`/projects/timeline/${timelineId}/pin`, {
      isPinned: pinStatus,
    });
    return response.json();
  };

  const createCloseout = async (projectId: string, payload: Record<string, any>) => {
    const response = await sendPostRequest(`/projects/${projectId}/completion-note`, payload);
    return response.json();
  };

  const updateCloseout = async (completionNoteId: string, values: Record<string, any>) => {
    const response = await sendPatchRequest(`/projects/completion-note/${completionNoteId}`, values);
    return response.json();
  };

  const getNoteValidationSchema = () => Promise.resolve(projectNoteValidation);
  const getCloseoutValidationSchema = () => Promise.resolve(projectCloseoutValidation);

  const getAccountStrategyNote = async (projectId: string) => {
    const response = await sendGetRequest(`/projects/${projectId}/timeline/strategy-notes`);
    return response.json();
  };

  return {
    createUserNote,
    updateUserNote,
    deleteUserNote,
    pinNote,
    createCloseout,
    updateCloseout,
    getNoteValidationSchema,
    getCloseoutValidationSchema,
    getAccountStrategyNote,
  };
};

export default useProjectNotesService;
